import React from "react";
import "./style.scss";
// import RightImg from "../../../../assets/images/about-section3-rightimg.jpg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCloud,
  faClock,
  faLeaf,
  faTruck,
} from "@fortawesome/free-solid-svg-icons";
import { useGetAboutPageContentQuery } from "../../../../services/AboutAPI";
import Loader from "../../fullPageLoader"
import { Link } from "react-router-dom";
import { useGetColorThemeQuery } from "../../../../services/commonAPI";

function Index() {
  const {
    data: aboutContent,
    error: contentError,
    isLoading: contentLoading,
  } = useGetAboutPageContentQuery();

      const {
            data: colorthemeData,
        } = useGetColorThemeQuery();
  

  if (contentLoading) return <Loader />;
  if (contentError) return <p>Failed to load page content</p>;

  // Get the first section of the about content
  const aboutSection = aboutContent?.data?.[0];

  return (
    <>
      {aboutSection && (
        <div className="section-3" data-aos="fade-up">
          <div className="container">
            <div className="about-product">
              <div className="row">
                <div className="col-md-3 col-lg-3 col-sm-12">
                  <FontAwesomeIcon
                    icon={faCloud}
                    style={{
                      color: "transparent",
                      stroke: "black",
                      strokeWidth: "20px",
                      fontSize: "24px",
                    }}
                  />
                  <h5 style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }}>{aboutSection.icon_text_one}</h5>
                  <p style={{ color: colorthemeData?.color_themes?.[0]?.paragraph_color || "##767676" }}>{aboutSection.icon_text_description_one}</p>
                </div>
                <div className="col-md-3 col-lg-3 col-sm-12">
                  <FontAwesomeIcon
                    icon={faClock}
                    style={{
                      color: "transparent",
                      stroke: "black",
                      strokeWidth: "20px",
                      fontSize: "24px",
                    }}
                  />
                  <h5 style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }}>{aboutSection.icon_text_two}</h5>
                  <p style={{ color: colorthemeData?.color_themes?.[0]?.paragraph_color || "##767676" }}>{aboutSection.icon_text_description_two}</p>
                </div>
                <div className="col-md-3 col-lg-3 col-sm-12">
                  <FontAwesomeIcon
                    icon={faLeaf}
                    style={{
                      color: "transparent",
                      stroke: "black",
                      strokeWidth: "20px",
                      fontSize: "24px",
                    }}
                  />
                  <h5 style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }}>{aboutSection.icon_text_three}</h5>
                  <p style={{ color: colorthemeData?.color_themes?.[0]?.paragraph_color || "##767676" }}> {aboutSection.icon_text_description_three}</p>
                </div>
                <div className="col-md-3 col-lg-3 col-sm-12">
                  <FontAwesomeIcon
                    icon={faTruck}
                    style={{
                      color: "transparent",
                      stroke: "black",
                      strokeWidth: "20px",
                      fontSize: "24px",
                    }}
                  />
                  <h5 style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }}>{aboutSection.icon_text_four}</h5>
                  <p style={{ color: colorthemeData?.color_themes?.[0]?.paragraph_color || "##767676" }}> {aboutSection.icon_text_description_four}</p>
                </div>
              </div>
            </div>
            {aboutSection && aboutSection?.is_section_three_active === 1 && (
              <div className="section3-bottomsec" data-aos="fade-up">
                <div className="row">
                  <div className="col-md-6 col-lg-6 col-sm-12">
                    <div className="left-sec">
                      <img
                        src={aboutSection.section_three_image_one}
                        alt="right-img"
                        className="img-fluid section-three-left"
                        loading="lazy"
                      />
                      <p className="new-finds" style={{ color: colorthemeData?.color_themes?.[0]?.text_color_one || "#a5a5a5" }}>
                        {aboutSection.section_three_text}
                      </p>
                      <p className="new-finds-head" style={{ color: colorthemeData?.color_themes?.[0]?.heading_color || "#000" }}>
                        {aboutSection.section_three_heading}
                      </p>
                    <Link to="/shop"> <button className="primary-button"
                        style={{
                          backgroundColor:
                            colorthemeData?.color_themes?.[0]?.primary_color ||
                            "#a76d50",
                        }}>SHOP NOW</button></Link> 
                    </div>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-12">
                    <img
                      src={aboutSection.section_three_image_two}
                      alt="right-img"
                      className="img-fluid right-img"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
}

export default Index;
